module.exports = __webpack_public_path__ + "static/media/care-left.29d81b32.png";